import React from 'react';
import { Link } from 'react-router-dom';

function Footer({ scrollToSection, refs }) {
    const currentYear = new Date().getFullYear();

    const primaryRed = '#C9262C';
    const accentGold = '#FFDD09';

    const handleScroll = (e, ref) => {
        e.preventDefault();
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
    };

    return (
        <footer style={{
            background: '#1A1A2E',
            padding: '60px 0 0',
            color: 'rgba(255,255,255,0.7)',
            fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
            borderTop: `3px solid ${accentGold}`
        }}>
            <div className="container" style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                    gap: '40px',
                    marginBottom: '40px'
                }}>

                    {/* Brand Column */}
                    <div>
                        <img
                            src="img/logos/logo-footer.png"
                            alt="SR PAY"
                            style={{ height: '40px', marginBottom: '16px' }}
                        />
                        <p style={{
                            fontSize: '13px',
                            lineHeight: 1.8,
                            color: 'rgba(255,255,255,0.5)',
                            marginBottom: '20px'
                        }}>
                            India's trusted utility services platform. Empowering 5,000+ retailers with mobile recharge, bill payments, insurance, travel booking & more.
                        </p>

                        {/* Social Media Icons - SVG Based */}
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                            {[
                                {
                                    name: 'Facebook',
                                    icon: (
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                        </svg>
                                    ),
                                    color: '#1877F2',
                                    url: 'https://facebook.com/srpay'
                                },
                                {
                                    name: 'Instagram',
                                    icon: (
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                                        </svg>
                                    ),
                                    color: '#E4405F',
                                    url: 'https://instagram.com/srpay'
                                },
                                {
                                    name: 'Twitter/X',
                                    icon: (
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                                        </svg>
                                    ),
                                    color: '#1DA1F2',
                                    url: 'https://twitter.com/srpay'
                                },
                                {
                                    name: 'YouTube',
                                    icon: (
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                            <path d="M23.498 6.186a3.016 3.016 0 00-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 00.502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 002.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 002.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
                                        </svg>
                                    ),
                                    color: '#FF0000',
                                    url: 'https://youtube.com/@srpay'
                                },
                                {
                                    name: 'LinkedIn',
                                    icon: (
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                                        </svg>
                                    ),
                                    color: '#0A66C2',
                                    url: 'https://linkedin.com/company/srpay'
                                },
                                {
                                    name: 'WhatsApp',
                                    icon: (
                                        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
                                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                                        </svg>
                                    ),
                                    color: '#25D366',
                                    url: 'https://wa.me/918053767570'
                                }
                            ].map((social, i) => (
                                <a
                                    key={i}
                                    href={social.url}
                                    target="_blank"
                                    rel="noreferrer"
                                    title={social.name}
                                    style={{
                                        width: '38px',
                                        height: '38px',
                                        borderRadius: '50%',
                                        background: 'rgba(255,255,255,0.08)',
                                        border: '1px solid rgba(255,255,255,0.15)',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        color: 'rgba(255,255,255,0.6)',
                                        textDecoration: 'none',
                                        transition: 'all 0.3s cubic-bezier(0.68, -0.55, 0.265, 1.55)'
                                    }}
                                    onMouseOver={(e) => {
                                        e.currentTarget.style.background = social.color;
                                        e.currentTarget.style.color = '#fff';
                                        e.currentTarget.style.borderColor = social.color;
                                        e.currentTarget.style.transform = 'translateY(-4px)';
                                        e.currentTarget.style.boxShadow = `0 8px 20px ${social.color}40`;
                                    }}
                                    onMouseOut={(e) => {
                                        e.currentTarget.style.background = 'rgba(255,255,255,0.08)';
                                        e.currentTarget.style.color = 'rgba(255,255,255,0.6)';
                                        e.currentTarget.style.borderColor = 'rgba(255,255,255,0.15)';
                                        e.currentTarget.style.transform = 'translateY(0)';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 style={{
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: '15px',
                            marginBottom: '20px',
                            position: 'relative',
                            paddingBottom: '12px'
                        }}>
                            Quick Links
                            <span style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                width: '30px',
                                height: '2px',
                                background: accentGold,
                                borderRadius: '2px'
                            }}></span>
                        </h3>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li style={{ marginBottom: '10px' }}>
                                <Link
                                    to="/"
                                    style={{
                                        color: 'rgba(255,255,255,0.5)',
                                        textDecoration: 'none',
                                        fontSize: '13px',
                                        transition: 'all 0.3s ease',
                                        display: 'inline-block',
                                        padding: '4px 0'
                                    }}
                                    onMouseOver={(e) => {
                                        e.target.style.color = accentGold;
                                        e.target.style.transform = 'translateX(5px)';
                                    }}
                                    onMouseOut={(e) => {
                                        e.target.style.color = 'rgba(255,255,255,0.5)';
                                        e.target.style.transform = 'translateX(0)';
                                    }}
                                >
                                    🏠 Home
                                </Link>
                            </li>
                            {[
                                { label: 'ℹ️ About Us', ref: refs?.aboutRef },
                                { label: '⚡ Services', ref: refs?.servicesRef },
                                { label: '📲 Download App', ref: refs?.downloadRef },
                                { label: '🤝 Join Us', ref: refs?.joinRef }
                            ].map((link, i) => (
                                <li key={i} style={{ marginBottom: '10px' }}>
                                    <a
                                        href={`#${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                                        onClick={(e) => handleScroll(e, link.ref)}
                                        style={{
                                            color: 'rgba(255,255,255,0.5)',
                                            textDecoration: 'none',
                                            fontSize: '13px',
                                            transition: 'all 0.3s ease',
                                            display: 'inline-block',
                                            padding: '4px 0'
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.color = accentGold;
                                            e.target.style.transform = 'translateX(5px)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.color = 'rgba(255,255,255,0.5)';
                                            e.target.style.transform = 'translateX(0)';
                                        }}
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Important Links – ALL scroll now */}
                    <div>
                        <h3 style={{
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: '15px',
                            marginBottom: '20px',
                            position: 'relative',
                            paddingBottom: '12px'
                        }}>
                            Important Links
                            <span style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                width: '30px',
                                height: '2px',
                                background: accentGold,
                                borderRadius: '2px'
                            }}></span>
                        </h3>
                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            {[
                                { label: '📞 Contact Us', ref: refs?.contactRef },
                                { label: '📋 Terms & Conditions', ref: refs?.termsRef },
                                { label: '🔒 Privacy Policy', ref: refs?.privacyRef },
                                { label: '↩️ Refund Policy', ref: refs?.refundRef },
                                { label: '❓ Help & Support', ref: refs?.contactRef },
                            ].map((link, i) => (
                                <li key={i} style={{ marginBottom: '10px' }}>
                                    <a
                                        href={`#${link.label.toLowerCase().replace(/\s+/g, '-')}`}
                                        onClick={(e) => handleScroll(e, link.ref)}
                                        style={{
                                            color: 'rgba(255,255,255,0.5)',
                                            textDecoration: 'none',
                                            fontSize: '13px',
                                            transition: 'all 0.3s ease',
                                            display: 'inline-block',
                                            padding: '4px 0'
                                        }}
                                        onMouseOver={(e) => {
                                            e.target.style.color = accentGold;
                                            e.target.style.transform = 'translateX(5px)';
                                        }}
                                        onMouseOut={(e) => {
                                            e.target.style.color = 'rgba(255,255,255,0.5)';
                                            e.target.style.transform = 'translateX(0)';
                                        }}
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    {/* Contact & Newsletter */}
                    <div>
                        <h3 style={{
                            color: '#fff',
                            fontWeight: 700,
                            fontSize: '15px',
                            marginBottom: '20px',
                            position: 'relative',
                            paddingBottom: '12px'
                        }}>
                            Get In Touch
                            <span style={{
                                position: 'absolute',
                                bottom: 0,
                                left: 0,
                                width: '30px',
                                height: '2px',
                                background: accentGold,
                                borderRadius: '2px'
                            }}></span>
                        </h3>

                        {/* Contact Info */}
                        <div style={{ marginBottom: '20px' }}>
                            {[
                                { icon: '📍', text: 'Plot No – 79, Sukhija Vihar, Block - B, Ghandi Path West, Jaipur, Rajasthan – 302012' },
                                { icon: '📧', text: 'support@srpay.co.in' },
                                { icon: '💬', text: '+91 80537 67570' }
                            ].map((item, i) => (
                                <div key={i} style={{
                                    display: 'flex',
                                    gap: '10px',
                                    marginBottom: '10px',
                                    fontSize: '13px',
                                    color: 'rgba(255,255,255,0.5)',
                                    lineHeight: 1.6
                                }}>
                                    <span style={{ flexShrink: 0, fontSize: '14px' }}>{item.icon}</span>
                                    <span>{item.text}</span>
                                </div>
                            ))}
                        </div>

                        {/* Newsletter */}
                        <p style={{
                            fontSize: '13px',
                            color: 'rgba(255,255,255,0.5)',
                            marginBottom: '12px'
                        }}>
                            Subscribe for updates & offers
                        </p>
                        <div style={{ display: 'flex', gap: '8px' }}>
                            <input
                                type="email"
                                placeholder="Your email"
                                style={{
                                    flex: 1,
                                    padding: '10px 16px',
                                    borderRadius: '25px',
                                    border: '1px solid rgba(255,255,255,0.2)',
                                    background: 'rgba(255,255,255,0.05)',
                                    color: '#fff',
                                    fontSize: '13px',
                                    outline: 'none',
                                    transition: 'all 0.3s ease'
                                }}
                                onFocus={(e) => {
                                    e.target.style.borderColor = accentGold;
                                    e.target.style.boxShadow = '0 0 15px rgba(255,221,9,0.15)';
                                }}
                                onBlur={(e) => {
                                    e.target.style.borderColor = 'rgba(255,255,255,0.2)';
                                    e.target.style.boxShadow = 'none';
                                }}
                            />
                            <button style={{
                                padding: '10px 20px',
                                borderRadius: '25px',
                                border: 'none',
                                background: `linear-gradient(135deg, ${accentGold}, #FF8C00)`,
                                color: '#1A1A2E',
                                fontWeight: 700,
                                fontSize: '13px',
                                cursor: 'pointer',
                                whiteSpace: 'nowrap',
                                transition: 'all 0.3s ease'
                            }}
                                onMouseOver={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 8px 20px rgba(255,221,9,0.3)';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = 'none';
                                }}>
                                Subscribe ✉️
                            </button>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar */}
                <div style={{
                    borderTop: '1px solid rgba(255,255,255,0.08)',
                    padding: '20px 0',
                    textAlign: 'center',
                    fontSize: '13px',
                    color: 'rgba(255,255,255,0.4)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    flexWrap: 'wrap',
                    gap: '10px'
                }}>
                    <p style={{ margin: 0 }}>
                        <span style={{ color: accentGold, fontWeight: 600 }}>SR PAY Private Limited</span> © {currentYear}. All Rights Reserved.
                    </p>
                    <p style={{ margin: 0 }}>
                        Made with ❤️ in India | Trusted by 5,000+ Partners
                    </p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;